module.exports = __webpack_public_path__ + "static/cta-b8dcbefc3d101ed18b8ecfbdff900170.png";